<div [class.dark-iris]="otherTheme">
    <mat-toolbar [color]="DevSite ? 'warn' : 'primary'" class="maintoolbar">
        <div fxLayout="row" fxLayoutAlign="space-between center" class="fullwidth">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
                <button type="button" *ngIf="User" mat-icon-button (click)="ToggleNavMenu()">
                    <mat-icon aria-label="Toggle Navigation Menu Button">menu</mat-icon>
                </button>
                <!-- <button type="button" (click)="ChangeTheme()"></button> -->
                <span class="mat-display-2 nobottommargin" *ngIf="!SmallSize || !User">IRIS</span>
                <div fxHide fxShow.gt-md fxLayout="column" fxLayoutAlign="end start">
                    <span class="mat-subheading-1 nobottommargin">Internal Request for Information System</span>
                    <span class="mat-subheading-1 nobottommargin">A Polk County Public Schools Project</span>
                </div>
                <div *ngIf="DevSite === true && !SmallSize">DEVELOPMENT SITE</div>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
                <app-user-info *ngIf="User" [user]="User"></app-user-info>
                <button
                    type="button"
                    fxHide
                    fxShow.gt-xs
                    class="noprint"
                    mat-icon-button
                    aria-label="About IRIS"
                    title="About..."
                    (click)="ToolbarAbout()"
                >
                    <mat-icon>help</mat-icon>
                </button>
                <button
                    type="button"
                    class="noprint"
                    *ngIf="User"
                    mat-icon-button
                    aria-label="Logout"
                    (click)="ToolbarLogout()"
                    title="Logout"
                >
                    <mat-icon>exit_to_app</mat-icon>
                </button>
            </div>
        </div>
    </mat-toolbar>
    <mat-sidenav-container class="sidenav">
        <mat-sidenav class="noprint mat-elevation-z5" *ngIf="User" [mode]="SmallSize ? 'over' : 'side'" [(opened)]="MenuOpen">
            <app-nav-menu
                [items]="MenuItems"
                [user]="User"
                [logout]="LogoutFn"
                [about]="AboutFn"
                (navigate)="Navigate($event)"
            ></app-nav-menu>
        </mat-sidenav>
        <mat-sidenav-content #sidenavcontent>
            <div fxLayout="column" fxLayoutAlign="start stretch" class="height100">
                <div class="devbar" *ngIf="DevSite === true && SmallSize"><div>Development Site</div></div>
                <div class="updatebar" *ngIf="UpdateAvailable === true">
                    <button type="button" mat-raised-button color="accent" (click)="GetUpdate()">
                        A site update is available. Click here for details.
                    </button>
                </div>
                <div
                    fxFlex="0 0 auto"
                    @warningBarRemoveTrigger
                    *ngIf="User?.OutOfOfficeActive && !SuppressOutOfOfficeAlert"
                    class="outofofficebar accentbackground200 padding-left"
                    fxLayout="row"
                    fxLayoutAlign="start center"
                    fxLayoutGap="20px"
                    fxLayout.lt-md="column"
                    fxLayoutAlign.lt-md="start center"
                    fxLayoutGap.lt-md="10px"
                >
                    <span>You have one or more active "Out of Office" designations currently in effect.</span>
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
                        <button type="button" mat-button color="accent" (click)="GoToOutOfOffice()">Click here to manage.</button>
                        <button type="button" mat-button color="primary" (click)="DismissOutOfOffice()">Dismiss</button>
                    </div>
                </div>
                <div fxFlex="1 1 auto" class="routerwrapper" fxLayout="column" fxLayoutAlign="start stretch">
                    <!-- [class.outofofficeheight]="User?.OutOfOfficeActive"
                [class.updatebarheight]="UpdateAvailable === true"
                [class.devbarheight]="DevSite === true" -->
                    <router-outlet class="content"></router-outlet>
                </div>
            </div>
        </mat-sidenav-content>
    </mat-sidenav-container>
</div>
